class BundleItems extends HTMLElement {
  constructor() {
    super();
    this.totalqty = 0;
    this.sections = {};
  }

  connectedCallback() {
    this.discountCodes = {
      1: "BUNDLE1",
      2: "BUNDLE2",
      3: "BUNDLE3",
      4: "BUNDLE4" // 4 or more -> use this
    };
    // discount values in dollars (as you requested)
    this.discountValues = {
      1: 0,
      2: 10,
      3:15,
      4: 20 // 4 or more => $4
    };
    this.capCount = 4;

    this.querySelectorAll('button.bundle_add-btn').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.querySelectorAll('.budnle_qty-button').forEach((button) =>
      button.addEventListener('click', this.onQtyButtonClick.bind(this))
    );

    this.progressElements = this.querySelectorAll(".quantity-meter-item");
    this.addToBundleButton = this.querySelector(".bundle-buy-button");
    this.compare_price = this.addToBundleButton.querySelector(".cta-price");
    this.btn_text = this.addToBundleButton.querySelector(".btn-text-cta");

    this.bundleVariants = this.getVariants();
    this.bundleVariantIds = this.bundleVariants.map((variant) => variant.id);
    console.log("bundle_variants", this.bundleVariantIds);

    this.addToBundleButton.addEventListener("click", this.addBundleCart.bind(this));
    this.selectedVariantids = [];
  }

  getVariants() {
    const bundleScript = document.getElementById("bundle-json");
    this.bundleProducts = JSON.parse(bundleScript.textContent.trim());
    const variants = this.bundleProducts.flatMap((product) => product.variants);
    return variants;
  }

  fetchExistingBundleQty(bundleVariantIds) {
    console.log("fetchExistingBundleQty", bundleVariantIds);
    return fetch('/cart.js').then((res) => { return res.json(); }).then((cart) => {
      var sum = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var li = cart.items[i];
        var vid = Number(li.variant_id || li.id);
        if (bundleVariantIds.indexOf(vid) !== -1) {
          sum += Number(li.quantity || 0);
        }
      }
      console.log("sum of cart total qty", sum);
      return sum;
    });
  }

  collectSelections() {
    return this.selectedProducts()
      .filter((variant) => variant.quantity > 0)
      .map((variant) => ({
        id: variant.id,
        quantity: variant.quantity,
      }));
  }

  addLineItem(item) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.id,
        quantity: item.quantity
      })
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || 'Add failed'); });
      return res.json();
    });
  }

  // sum quantities in array of items
  sumQuantities(items) {
    console.log("sum of item");
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      sum += Number(items[i].quantity || 0);
    }
    return sum;
  }

  addAllItemsSequentially(items) {
    return items.reduce((promise, item) => {
      return promise.then(() => this.addLineItem(item));
    }, Promise.resolve());
  }

  addBundleCart(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    this.addToBundleButton.disabled = true;
    this.addToBundleButton.classList.add("loading")
    const selections = this.collectSelections();
    if (!selections.length) {
      console.warn('BundleItems: no selections to add');
      return;
    }
    console.log("variantid", this.bundle);
    // fetch existing qty, then add selected items, then compute total and redirect
    this.fetchExistingBundleQty(this.bundleVariantIds)
      .then((existingQty) => {
        return this.addAllItemsSequentially(selections)
          .then(() => {
            const newlyAddedQty = this.sumQuantities(selections);
            const finalTotal = Number(existingQty || 0) + Number(newlyAddedQty || 0);
window.location.href = '/checkout'
            // let count = finalTotal >= this.capCount ? this.capCount : finalTotal;
            // if (count <= 0) {
            //   window.location.href = '/checkout';
            //   return;
            // }
            // const code = this.discountCodes[count] || null;
            // console.log('coupon code', count);
            // if (!code) {
            //   return;
            // }
            // window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          });
      })
      .catch(err => {
        console.error('BundleItems add flow error', err);
      });
  }

  onQtyButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const container = button.closest(".bundle-quantity");
    const qtyElement = container.querySelector(".budnle_qty-display");
    const addBtn = container.querySelector(".bundle_add-btn");

    let currentQty = parseInt(qtyElement.textContent, 10);

    if (button.textContent.trim() === "+") {
      this.updateQuantity(qtyElement, currentQty + 1);
    } else if (button.textContent.trim() === "-") {
      this.updateQuantity(qtyElement, currentQty - 1, addBtn);
    }
    this.selectedProducts();
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentButton = event.currentTarget;
    const bundleElement = currentButton.closest(".bundle-quantity");
    const qtyElement = bundleElement.querySelector(".budnle_qty-display");
    if (bundleElement.classList.contains("is-active")) {
      bundleElement.classList.remove("is-active");
    }
    this.updateQuantity(qtyElement, 1);
  }

  selectedProducts() {
    // get all qty displays from non-active bundles
    const qtyDisplays = Array.from(
      this.querySelectorAll(".bundle-quantity:not(.is-active) .budnle_qty-display")
    );

    // build map of {variantId: quantity}
    const variantQuantities = qtyDisplays.map((ele) => ({
      id: Number(ele.dataset.firstVariant),
      quantity: Number(ele.textContent.trim())
    }));

    // filter and enrich bundleVariants
    this.selectedVariantids = variantQuantities.map(v => v.id);

    return this.bundleVariants
      .filter((variant) => this.selectedVariantids.includes(variant.id))
      .map((variant) => {
        const found = variantQuantities.find(v => v.id === variant.id);
        return {
          ...variant,
          quantity: found ? found.quantity : 0
        };
      });
  }

  updateQuantity(element, value, addBtn = null) {
    if (value <= 0) {
      element.textContent = 0;
      element.closest(".bundle-quantity").classList.add("is-active");
    } else {
      element.textContent = value;
    }
    this.selectedProducts();
    this.renderContent();
  }

  renderContent() {
    this.totalqty = Array.from(this.querySelectorAll('.budnle_qty-display')).reduce((total, el) => {
      return total + parseInt(el.textContent, 10);
    }, 0);

    // Reset all circles
    this.progressElements.forEach((el) => {
      const nodes = el.querySelectorAll('.quantity-meter-item__circle, .quantity-meter-item__circle-inner');
      nodes.forEach((node) => {
        if (node.classList.contains("quantity-meter-item__circle")) {
          node.nextElementSibling?.classList.add("subdued");
        }
        node.classList.remove("filled");
      });
    });

    // Fill circles up to totalQty
    const max = Math.min(this.totalqty, this.progressElements.length);
    for (let i = 0; i < max; i++) {
      const nodes = this.progressElements[i].querySelectorAll('.quantity-meter-item__circle, .quantity-meter-item__circle-inner');
      nodes.forEach((node) => {
        if (node.classList.contains("quantity-meter-item__circle")) {
          node.nextElementSibling?.classList.remove("subdued");
        }
        node.classList.add("filled");
      });
    }
    this.updataCTA();
    this.totalPrice();
  }

  // return discount value in dollars based on item count
  getDiscountValue(itemCount) {
    if (itemCount <= 0) return 0;
    if (itemCount >= 4) return this.discountValues[4];
    return this.discountValues[itemCount] || 0;
  }

  totalPrice() {
    // Calculate total in the same units you store prices (Shopify usually uses cents)
    // Keep usage consistent with your prior code which used product.price + formatMoney
    const total = this.selectedProducts().reduce((sum, product) => {
      // product.price may already be an integer representing cents; preserve current behavior
      const price = Number(product.price || 0) * Number(product.quantity || 0);
      return sum + price;
    }, 0);


    const discountPercent = this.getDiscountValue(this.totalqty);
    const totalELE= total/100
  const discountAmount =Math.ceil(totalELE * (discountPercent / 100));

    const discountedTotal = Math.round(totalELE - discountAmount)*100;
 console.log("TOtal",totalELE,total,discountedTotal)
    let priceHtml = "";

   if (totalELE === discountedTotal) {
    // No discount → show only total
    priceHtml = `<span class="discounted-price">${formatMoney(discountedTotal, theme.moneyFormat)}</span>`;
  } else {
    // Discount applied → show both
    priceHtml =
      `<span class="original-price" style="text-decoration:line-through;margin-right:8px;">${formatMoney(total, theme.moneyFormat)}</span>` +
      `<span class="discounted-price">${formatMoney(discountedTotal, theme.moneyFormat)}</span>`;
  }

  this.compare_price.innerHTML = priceHtml;

    // Update CTA text to show count and "after discount" price
    // const itemText = `${this.totalqty} item${this.totalqty !== 1 ? 's' : ''}`;
    // const saveText = discountValueDollars > 0 ? ` Save ${formatMoney(discountCents, theme.moneyFormat)}` : '';
    // this.btn_text.textContent = `${itemText} — ${formatMoney(discountedTotal, theme.moneyFormat)}${saveText}`;
  }

  updataCTA() {
    console.log("ss", this.totalqty);
    if (this.totalqty > 0) {
      this.addToBundleButton.removeAttribute('disabled');
    }
    else {
      this.addToBundleButton.setAttribute('disabled', '');
    }
  }
}

// Register the custom element
customElements.define('bundle-items', BundleItems);
